        // Select the rich-text__blocks div
        var richTextBlocks = document.querySelector('.rich-text__blocks');

       // Select the second multicolumn-card inside the multicolumn-list__item
        var firstMulticolumn = document.querySelectorAll('.multicolumn-list__item')[0];

       // Select the second multicolumn-card inside the multicolumn-list__item
        var secondMulticolumn = document.querySelectorAll('.multicolumn-list__item')[1];
        
        // Select the second multicolumn-card inside the multicolumn-list__item
        var secondMulticolumnCard = document.querySelectorAll('.multicolumn-list__item .multicolumn-card')[1];

        // Add class 'multicolumnFirst' to firstMulticolumn and 'multicolumnSecond' to secondMulticolumnCard
        firstMulticolumn.classList.add('multicolumnFirst');
        secondMulticolumn.classList.add('multicolumnSecond');
        
        // Select the collection div
        var collection = document.querySelector('.collection');
        
        // Prepend the rich-text__blocks div to the second multicolumn-card
        secondMulticolumnCard.prepend(richTextBlocks);
        
        // Append the collection div after rich-text__blocks inside the second multicolumn-card
        secondMulticolumnCard.appendChild(collection);